import { createFileRoute } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Plans } from "@/components/landing/Plans";
import { WhyChoose } from "@/components/landing/WhyChoose";
import { Entertainment } from "@/components/landing/Entertainment";
import { CallbackForm } from "@/components/landing/CallbackForm";
import { Footer } from "@/components/landing/Footer";
import { FloatingActions } from "@/components/landing/FloatingActions";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Tata Play DTH New Connection — Book Online | 6364894003" },
      { name: "description", content: "Book a Tata Play DTH new connection. Check current offers, choose your set-top box and request doorstep installation where available." },
      { property: "og:title", content: "Tata Play DTH New Connection — Book Online | 6364894003" },
      { property: "og:description", content: "Book a Tata Play DTH new connection. Check current offers, choose your set-top box and request doorstep installation where available." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://nearbyservices.co.in/" },
    ],
    links: [{ rel: "canonical", href: "https://nearbyservices.co.in/" }],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <Plans />
        <WhyChoose />
        <Entertainment />
        <section className="bg-secondary/40 py-16 sm:py-24">
          <div className="mx-auto max-w-2xl px-4">
            <CallbackForm id="form" />
          </div>
        </section>
      </main>
      <Footer />
      <FloatingActions />
      <Toaster richColors position="top-center" />
    </div>
  );
}
